export type AppErrorContext = Record<string, unknown>

export class AppError extends Error {
  constructor(
    message: string,
    public readonly errorCode: string,
    public readonly context: AppErrorContext = {},
    options?: ErrorOptions,
  ) {
    super(message, options)
    this.name = 'AppError'
  }

  toLogContext(): AppErrorContext {
    return {
      errorCode: this.errorCode,
      ...this.context,
    }
  }
}
